import {createGlobalStyle} from "styled-components";

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'IconicS115';
        src: url('/boston.ttf') format('truetype');
        font-display: swap;
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    html {
        background-color: ${({theme}) => theme.backgroundColor};
        -webkit-text-size-adjust: 100%;
    }

    body {
        margin: 0;
        min-height: 100%;
        font-family: ${({theme}) => theme.font.body};
        font-size: 16px;
        line-height: 1.55;
        color: ${({theme}) => theme.color};
        background-color: ${({theme}) => theme.backgroundColor};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /* clip, not hidden: contains stray overflow without turning the body
           into a scroll container, which would break the sticky toolbars. */
        overflow-x: clip;
    }

    /* Ambient light so pure black never looks flat. */
    body::before {
        content: '';
        position: fixed;
        inset: 0;
        pointer-events: none;
        z-index: 0;
        background:
                radial-gradient(1200px 600px at 12% -10%, rgba(214, 218, 225, 0.07), transparent 60%),
                radial-gradient(900px 500px at 90% 0%, rgba(180, 186, 196, 0.05), transparent 65%);
    }

    #root {
        position: relative;
        z-index: 1;
        isolation: isolate;
    }

    h1, h2, h3, h4, h5, h6 {
        margin: 0;
        font-weight: 700;
        letter-spacing: -0.02em;
        line-height: 1.1;
    }

    p {
        margin: 0;
    }

    a {
        color: inherit;
        text-decoration: none;
    }

    button {
        font: inherit;
        color: inherit;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
    }

    input, textarea, select {
        font: inherit;
    }

    ul, ol {
        margin: 0;
        padding: 0;
    }

    img, video {
        max-width: 100%;
    }

    ::selection {
        background-color: ${({theme}) => theme.accent};
        color: ${({theme}) => theme.accentContrast};
    }

    :focus-visible {
        outline: 2px solid ${({theme}) => theme.accent};
        outline-offset: 3px;
    }

    * {
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
    }

    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.16);
        border-radius: 999px;
        border: 3px solid transparent;
        background-clip: content-box;
    }

    ::-webkit-scrollbar-thumb:hover {
        background-color: rgba(255, 255, 255, 0.28);
        background-clip: content-box;
    }

    @media (prefers-reduced-motion: reduce) {
        *, *::before, *::after {
            animation-duration: 0.001ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.001ms !important;
            scroll-behavior: auto !important;
        }
    }
`

export default GlobalStyle
